import crypto from 'isomorphic-webcrypto';
export function getRandomValues(length) {
    return crypto.getRandomValues(new Uint8Array(length));
}
async function performCryptoOperation(operation, key, iv, data) {
    const result = await crypto.subtle[operation]({
        name: 'AES-CBC',
        iv
    }, key, data);
    return new Uint8Array(result);
}
export async function decrypt(key, iv, data) {
    return performCryptoOperation('decrypt', key, iv, data);
}
export async function encrypt(key, iv, data) {
    return performCryptoOperation('encrypt', key, iv, data);
}
export async function exportKey(key) {
    const result = await crypto.subtle.exportKey('raw', key);
    return new Uint8Array(result);
}
export async function generateEncryptDecryptKeys() {
    return crypto.subtle.generateKey({
        name: 'AES-CBC',
        length: 256
    }, true, ['encrypt', 'decrypt']);
}
export async function importKey(bytes) {
    return crypto.subtle.importKey('raw', bytes, {
        name: 'AES-CBC'
    }, true, ['encrypt', 'decrypt']);
}
